/**
 * TOSS Web Application — имя продукта, набранное один раз на весь продукт
 *
 * До 27.08.2026 лок-ап «ТОСС АТМОСФЕРА» жил разметкой ВНУТРИ вызова `SidebarBrand` в
 * `components/layout/Sidebar.tsx`, а на двери его не было вовсе: экран входа встречал фразой
 * «Добро пожаловать в личный кабинет компании ТОСС!», после которой человек попадал в
 * приложение с другим названием. Владелец это и назвал: «не хватает слова АТМОСФЕРА, чтобы как
 * в боковой панели».
 *
 * Теперь имя набирает один компонент, и его печатают обе поверхности: дверь (`AuthBrandPanel`) и
 * комната (`SidebarBrand`). Разъехаться им больше негде.
 *
 * Цвет второго слова — `--brand-accent`, тот же токен, на который смотрит рейл
 * (`--sidebar-brand-accent`). Первое слово остаётся текстовым: знак рисует `logo-icon.svg`
 * рядом, а не буквы.
 */

import type { BrandSurface } from './brandLabels';

// ============================================================================
// Types
// ============================================================================

export interface BrandWordmarkProps {
  surface: BrandSurface;
  className?: string;
}

// ============================================================================
// Component
// ============================================================================

export function BrandWordmark({ surface, className = '' }: BrandWordmarkProps): JSX.Element {
  if (surface === 'client') {
    return <span className={className}>ТОСС</span>;
  }

  return (
    <span className={className}>
      <span className="text-[var(--color-text-primary)]">ТОСС </span>
      <span className="text-[var(--brand-accent)]">АТМОСФЕРА</span>
    </span>
  );
}

export default BrandWordmark;
